'use strict';

var extractAlpha = require('../../../../../../../../_virtual/extractAlpha.cjs');

var hasRequiredExtractAlpha;

function requireExtractAlpha () {
	if (hasRequiredExtractAlpha) return extractAlpha.__exports;
	hasRequiredExtractAlpha = 1;

	/**
	 * extract alpha percentage from an alpha hex code
	 */ const extractAlpha$1 = (alphaHex)=>{
	    const alpha = alphaHex.slice(7, 9);
	    const opacity = parseInt(alpha, 16) / 255;
	    return Math.round(opacity * 100);
	};

	extractAlpha.__exports.extractAlpha = extractAlpha$1;
	
	return extractAlpha.__exports;
}

exports.__require = requireExtractAlpha;
//# sourceMappingURL=extractAlpha.cjs.map
